export default {
    about: "Acerca de la Academia",
    areas: "Áreas",
    category: "Área de Conocimientos",
    company_agency: "Comercio",
    document: "CI",
    email: "Tu dirección de e-mail",
    explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Te ofrecemos cursos de capacitación online (en video), virtuales (con capacitadores en vivo), presenciales, y acceso preferencial a contenidos exclusivos.",
    in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days: "En caso de dudas sobre el funcionamiento de la plataforma, los puntos o cualquier información, complete el formulario para ponerse en contacto con nuestro equipo de soporte.",
    name: "Nombre y Apellido",
    no_company_agency_found: "No se encontraron tiendas",
    no_notification_available: "0 (CERO) notificaciones disponibles",
    project_name: "Academia Inca",
    recover_password: "Recuperá tu contraseña",
    subject: "Asunto",
    support: "Contactanos",
    tags: "Destacados",
    training_plural: "Cursos",
    training: "Curso",
    type_to_search: "Escribí aquí para buscar",
    welcome_to: "Bienvenido/a a la",
    what_do_you_want_to_learn_today: "¿Qué querés aprender hoy?",
    state: 'Província'
}